import React, { useMemo, useCallback, useEffect } from 'react';
import PropTypes from 'prop-types';
import { slugify } from '../../utilities/slugify';
import MaterialIcon from "../elements/MaterialIcon.jsx";

export default function TabUsageInner({ activeTab, content, label, icon, onTabClick, tabsInstance }) {

	const labelSlug = useMemo(() => {
		return slugify(label);
	}, [label]);

	const isActive = useMemo(() => {
		return activeTab === labelSlug;
	}, [activeTab, labelSlug]);

	const linkClick = useCallback((event) => {
		event.preventDefault();
		if(onTabClick) {
			onTabClick(event.currentTarget.dataset.label);
		}
	}, [onTabClick]);

	useEffect(() => {
		if(tabsInstance && activeTab === labelSlug) {
			tabsInstance.select(labelSlug);
		}
	}, [activeTab, labelSlug, tabsInstance]);

	return (
		<li
			className='tab'
		>
			<a
				className={`${isActive ? 'active' : ''}  waves-effect`}
				onClick={linkClick}
				data-label={labelSlug}
			>
				{!!icon &&
				<MaterialIcon>{icon}</MaterialIcon>
				}
				<div className={`${!!icon ? 'hint_text' : ''}`}>
					{content || label}
				</div>
			</a>
		</li>
	);
}

TabUsageInner.propTypes = {
	activeTab: PropTypes.string.isRequired,
	label: PropTypes.string.isRequired,
};